import { toSurveyTO, type SurveyTO } from './Survey';

export type DataAnnotationPatientProfile = Record<string, string | null>;

export type ObservationRecord = {
  eventDate: string;
  value: number | null;
  unit: string | null;
  range: any[] | null;
  interpretation: unknown | null;
};
export type Observations = Record<string, ObservationRecord[]>;

export type DataAnnotationAdditionalContent = {
  editable?: boolean;
  editType?: string;
  formatType?: string;
  value: string;
};

export type DataAnnotationAdditionalSection = Record<
  string,
  DataAnnotationAdditionalContent
>;
export interface CaseTO {
  caseId: number;
  caseType: string;
  eventType: string;
  eventDate: string;
  patientHeader: DataAnnotationPatientProfile;
  observationTable: Observations;
  additionalSection: DataAnnotationAdditionalSection;
  surveys?: SurveyTO[];
}

export const toCaseTO = (caseData: any): CaseTO => ({
  caseId: caseData.caseId,
  caseType: caseData.caseType,
  eventType: caseData.eventType,
  eventDate: caseData.eventDate,
  patientHeader: caseData.patientHeader,
  observationTable: caseData.observationTable,
  additionalSection: caseData.additionalSection,
  surveys: caseData.surveys ? caseData.surveys.map(toSurveyTO) : undefined,
});
